/** Zweiter Faktor nach dem E-Mail-Link: sechsstelliger Code aus der Authenticator-App. */
import { Marke } from "../ui/Marke";
import { useState, type FormEvent } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate, useSearchParams } from "react-router";
import { Button, Notice, TextField } from "../ui";
import { api, ApiFehler, rufe } from "../api/client";
import { useAbmelden } from "../api/ich";

export function ZweiterFaktor() {
  const [params] = useSearchParams();
  const weiterParam = params.get("weiter") ?? "";
  const weiter = /^\/[a-z0-9\-/]*$/i.test(weiterParam) ? weiterParam : "/";
  const navigate = useNavigate();
  const qc = useQueryClient();
  const abmelden = useAbmelden();
  const [code, setCode] = useState("");
  const [fehler, setFehler] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);

  async function senden(e: FormEvent) {
    e.preventDefault();
    setFehler(null);
    setLaeuft(true);
    try {
      await rufe(api.api.konto.totp.pruefen.$post({ json: { code: code.trim() } }));
      await qc.invalidateQueries({ queryKey: ["ich"] });
      navigate(weiter, { replace: true });
    } catch (err) {
      setFehler(err instanceof ApiFehler ? err.message : "Das hat nicht geklappt.");
    } finally {
      setLaeuft(false);
    }
  }

  return (
    <div className="app-public">
      <form className="app-public__card" onSubmit={senden} noValidate>
        <div className="app-public__brand">
          <Marke size={40} />
          <span className="sc-strong">MeinRegalladen</span>
        </div>
        <h1 className="title">Code aus der App</h1>
        <p className="sc-muted">Zum Schutz des Ladens bitte den sechsstelligen Code aus der Authenticator-App eingeben.</p>
        <TextField label="Code" value={code} onChange={(e) => setCode(e.target.value.slice(0, 9))} autoComplete="one-time-code" placeholder="123 456" hint="Oder ein Wiederherstellungscode (abcd-efgh)" error={fehler ?? undefined} autoFocus />
        <Button type="submit" variant="primary" size="lg" icon="lock" block loading={laeuft} disabled={!/^(\d{3}\s?\d{3}|[a-z0-9]{4}-?[a-z0-9]{4})$/i.test(code.trim())}>
          Bestätigen
        </Button>
        <Notice tone="info" title="Kein Zugriff auf die App?">Ein Wiederherstellungscode geht auch. Ohne beides kann der Anbieter die Zwei-Faktor-Anmeldung zurücksetzen – bitte per E-Mail melden.</Notice>
        <Button variant="quiet" onClick={() => void abmelden()}>Abmelden</Button>
      </form>
    </div>
  );
}
